<script>
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher();

    export let colores;
    export let valor;
    export let label;
</script>

<style>
    label {
        display: block;
        margin-bottom: 0.5rem;
        width: 100%;
    }

    .form-control {
        padding: 0.5rem 0;
        width: 100%;
        margin: 0.25rem 0;
    }

    .colores {
        display: grid;
        grid-template-columns: repeat(9, 1fr);
        grid-gap: 3px;
    }

    .color {
        width: 100%;
        padding-bottom: 100%;
        background: var(--color);
        border-radius: var(--radio-global);
        transition: .3s;
        border: 1px solid transparent;
    }

    :focus,
    .activo {
        transform: scale(1.1);
        box-shadow: 0 6px 6px -6px rgba(0, 0, 0, .2);
        z-index: 10;
    }

    .activo:focus {
        outline: none;
    }

    .alguno-activo .color:not(.activo ) {
        transform: scale(.85);
    }
</style>

<div class="form-control">
    <label>{label}</label>

    <div class="colores" class:alguno-activo={colores.filter(x => x === valor).length}>
        {#each colores as color}
            <button type="button" class="color" style="--color: {color}"
                    tabindex={valor === color ? -1 : 0}
                    class:activo={valor === color}
                    on:click={() => dispatch('color-seleccionado', color)}>
            </button>
        {/each}
    </div>
</div>